export default __webpack_public_path__ + "static/media/default-news-hero.5b0e3141.svg";